<template>
  <div class='wrapper'>
     
    <div tabindex='1' id='main' class='main' v-on:keyup="onKeyUp" v-on:keydown="onKeyDown" v-on:mousemove="onMouseMove"/>
    <div id="blocker" style="position: absolute;top:20px">
      <div id="instructions">
        <span style="font-size:36px">Click to explore my portfolio</span>
        <br /><br />
        Keyboard and mouse only. #MobileLast<br /><br />
        
        M - change from FPV to drone control<br /><br />
        
        FPV uses:<br />
        WASD + cursor<br /><br />

        Drone uses: <br />
          Q/Z - Throttle<br />
          W/S - Pitch<br />
          A/D - Roll<br />
          <br />
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'
import * as OIMO  from 'oimo'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { FirstPersonControls } from 'three/examples/jsm/controls/FirstPersonControls';
import { PointerLockControls } from 'three/examples/jsm/controls/PointerLockControls';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js';
import Room from '../objects/Room.js'
import { AmbientLight } from 'three';
import PickHelper from '../helpers/PickHelper.js'

//inspiration:
// https://bruno-simon.com/

//resources:
// https://github.com/mrdoob/three.js/blob/master/examples/misc_controls_pointerlock.html
// https://github.com/mrdoob/three.js/blob/dev/examples/jsm/controls/PointerLockControls.js
// https://forum.vuejs.org/t/basic-keyboard-events-not-working/2073  (tabindex)
let modes={
  fpv:'fpv',
  drone:'drone'
}
//https://www.programmersought.com/article/77261746827/
//https://github.com/chandlerprall/Physijs/issues/97

  
export default {
  name: 'App',
  components: {
  },
  data: function(){
    return {
      mode: modes.fpv,
      prevTime: 0,
			velocity: new THREE.Vector3(),
      direction: new THREE.Vector3(),
      moveForward: false,
			moveBackward: false,
			moveLeft: false,
			moveRight: false,
			canJump: false,
      camera: null,
      scene: new THREE.Scene(),
      renderer: new THREE.WebGLRenderer( { antialias: true })
    }
  },
  mounted: function(){
   this.init();
    
  },
  methods:{
    init: function(){    
        this.clock = new THREE.Clock();    
        let mainDiv = document.getElementById("main")
        
        mainDiv.appendChild( this.renderer.domElement );
        console.log(mainDiv.clientWidth, mainDiv.clientHeight);
        this.camera = new THREE.PerspectiveCamera( 70, mainDiv.clientWidth / mainDiv.clientHeight, .1, 1000 );
        this.camera.position.y = 1;
        
        // camera
        this.camera.position.set( 2, 1.6, 2.01 ); // OrbitControls target is the origin

        this.renderer.setPixelRatio( window.devicePixelRatio );
        
        this.renderer.setSize( mainDiv.clientWidth, mainDiv.clientHeight );
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.renderer.shadowMap.enabled = true;
        //window.addEventListener( 'resize', onWindowResize, false );
        // controls
        this.controls = new PointerLockControls( this.camera, this.renderer.domElement );
        
        this.scene.add( this. controls.getObject() );
        //this.controls.isLocked =true;
        var blocker = document.getElementById( 'blocker' );
        var instructions = document.getElementById( 'instructions' );
        let _this = this;
        instructions.addEventListener( 'click', function () {
          _this.controls.lock();
          mainDiv.focus();
				}, false );

				this.controls.addEventListener( 'lock', function () {

					instructions.style.display = 'none';
					blocker.style.display = 'none';

				} );

				this.controls.addEventListener( 'unlock', function () {

					blocker.style.display = 'block';
					instructions.style.display = '';

        } );

        this.scene.add(new THREE.AmbientLight(0x555555, .75));

        this.canvas = this.renderer.domElement;

        
			this.composer = new EffectComposer(this.renderer );

			let renderPass = new RenderPass(this.scene, this.camera );
			this.composer.addPass( renderPass );

			this.outlinePass = new OutlinePass( new THREE.Vector2( window.innerWidth, window.innerHeight ), this.scene, this.camera );
			this.composer.addPass( this.outlinePass );//
			
			var params = {
				edgeStrength: 5.0,
				edgeGlow: 3.0,
				edgeThickness: 2.0,
				pulsePeriod: 2,
				rotate: false,
				usePatternTexture: false
			};

			this.outlinePass.edgeStrength = params.edgeStrength
			this.outlinePass.edgeGlow = params.edgeGlow;
			this.outlinePass.edgeThickness =params.edgeThickness
			this.outlinePass.pulsePeriod = params.pulsePeriod;
			this.outlinePass.usePatternTexture = params.usePatternTexture;
			this.outlinePass.visibleEdgeColor.set( '#ffffff' );	
			this.outlinePass.hiddenEdgeColor.set( '#aaaaff' );
      
      this.setupPhysics();
      this.setupScene();        
      this.setupControls();
      this.animate();
    },
    setupPhysics: function(){
      
      // Oimo
      this.world = new OIMO.World({ 
        timestep: 1/60,
        iterations: 8,
        broadphase: 2,
        worldscale: 1,
        random: true,
        info:false,
        gravity: [0,-9.8,0]
    });
      //this.view = new OIMO.View();
      

      var options = {
        type:'box',
        size:[1, 1, 1],
        pos:[0,10,-8],
        density:1,
        move:true
    }

      this.box = this.world.add( options );   

    },
    fpvKeyDown: function(){
        switch ( event.keyCode ) {

						case 38: // up
						case 87: // w
							this.moveForward = true;
							break;

						case 37: // left
						case 65: // a
							this.moveLeft = true;
							break;

						case 40: // down
						case 83: // s
							this.moveBackward = true;
							break;

						case 39: // right
						case 68: // d
							this.moveRight = true;
							break;

						case 32: // space
							break;

					}
    },
    droneKeyDown: function(event){
      console.log(event);

      switch ( event.keyCode ) {

            case 81: //q
              this.drone.throttleUp();
              break;
            case 90://z
              this.drone.throttleDown();
              break;
						case 38: // up
						case 87: // w
							this.drone.pitchdown();
							break;

						case 37: // left
						case 65: // a
							this.drone.rollLeft();
							break;

						case 40: // down
						case 83: // s
							this.drone.pitchUp();
							break;

						case 39: // right
						case 68: // d
							this.drone.rollRight();
							break;

						case 32: // space
							break;

					}
    },
    cycleMode: function(){
      if(this.mode === modes.drone)
        this.mode = modes.fpv;
      else
        this.mode = modes.drone;
    },
    onKeyDown: function ( event ) {

      if(event.code === 'KeyE'){
        this.focusOnObject();
        return;
      }

      if(event.code === 'KeyM'){
        this.cycleMode();
        return;
      }

      if(event.code === 'KeyC'){
        this.camera.position.y=0;
      }


      switch(this.mode){
        case modes.fpv:
          this.fpvKeyDown(event)
          break;
        case modes.drone:
          this.droneKeyDown(event);
          break;
      }
      
        },
        onKeyUp: function ( event ) {
					switch ( event.keyCode ) {

						case 38: // up
						case 87: // w
							this.moveForward = false;
							break;

						case 37: // left
						case 65: // a
							this.moveLeft = false;
							break;

						case 40: // down
						case 83: // s
							this.moveBackward = false;
							break;

						case 39: // right
						case 68: // d
							this.moveRight = false;
							break;

					}

				},
    setupControls: function(){	
      
      // Enumerate objects that support outlines
        // add raytracing [DONE]
        // add auto-highlight of hovered outlines
        // only highlight when sufficiently close
        // when E is pressed, while object highlighted, get object mode 
        // toggle mode to highlighted object
        // turn off ray-tracing while in focus mode

      this.focusObjects = this.getFocusObjects();
      this.pickHelper = new PickHelper();
      this.pickPosition = new THREE.Vector2();
      
      
      // setupControls	
    },
    onMouseMove(event){
      this.setPickPosition(event); // mouse
      console.log("mouse move")
      let picked = this.pickHelper.pick(this.pickPosition, this.scene, this.camera);
      this.highlightObject(picked);
    },    	
    getCanvasRelativePosition(event) {
      const rect = this.canvas.getBoundingClientRect();
      return {
        x: (event.clientX - rect.left) * this.canvas.width  / rect.width,
        y: (event.clientY - rect.top ) * this.canvas.height / rect.height,
      };
      },
    setPickPosition: function(event) {
      //const pos = this.getCanvasRelativePosition(event);
      //this.pickPosition.x = (pos.x / this.canvas.width ) *  2 - 1;
      //this.pickPosition.y = (pos.y / this.canvas.height) * -2 + 1;  // note we flip Y
      this.pickPosition.x = (.5 ) *  2 - 1;
      this.pickPosition.y = (.5) * -2 + 1;  // note we flip Y
      //this.pickPosition.x = this.canvas.width/2;
      //this.pickPosition.y = -this.canvas.height/2;
    },
    findFirstFocus: function(picked){
      if(!picked)
        return null;
      // iterate the intersections,
      // if an object supports
      let closestFocusObject = null; 
      let _this = this;

      // get the object directly in front
      picked.intersectedObjects.forEach((i)=>{        
        if(closestFocusObject)
          return;
        _this.focusDist = 4;
        let obj = i.object;
        let userData = obj.userData;
        if(!userData ) return;

        if(typeof userData.canFocus === 'function'){
            if(userData.canFocus())
              if(i.distance < _this.focusDist)
                closestFocusObject= userData
        }        
      });
      return closestFocusObject;
    },
    highlightObject: function(picked){
      let focus = this.findFirstFocus(picked)
      if(focus === null){
        this.setOutlinedMeshes([]);
        return;}
      this.setOutlinedMeshes(focus.getOutlineMeshes());
      //_this.focusOnObject(userData); // user interaction
    },
    setOutlinedMeshes(meshes){
      // the collision zones are being obscured by transparent outline and pickDetection meshes: https://stackoverflow.com/questions/11165345/three-js-webgl-transparent-planes-hiding-other-planes-behind-them
      // so to work around that (for the most part), we just toggle visibility of outline meshes as they're set/cleared.
      // this is why all components have separate outline / pickDetection meshes from their textured meshes.
      if(!meshes)
        this.outlinePass.selectedObjects = [];
      else{
        this.outlinePass.selectedObjects = meshes;
      }        
    },
    focusOnObject: function(focusedObject){
      let picked = this.pickHelper.pick(this.pickPosition, this.scene, this.camera);
      let focus = this.findFirstFocus(picked)
      if(focus === null)
        return;      

      // get the mode for the object directly in front
      let focusMode = focus.getFocusMode();
      // switch to that mode (input, camera, etc)
      this.mode = focusMode;
      // turn off focus highlighting      
      this.highlighting = false;
      // if this.mode is book, then what do they controls do now?
      // bring the book up to the camera, oriented up with the camera
      // keys turn the book around?
      //

    },
    getFocusObjects: function(){
      return this.room.getFocusObjects();
    },
    setupScene: function(){
        var texture = new THREE.TextureLoader().load( require('../assets/crate.gif') );
				var geometry = new THREE.BoxBufferGeometry( 1, 1, 1 );
				var material = new THREE.MeshBasicMaterial( { map: texture });

        this.mesh = new THREE.Mesh( geometry, material );
        this.mesh.position.z = -3;
        this.mesh.position.y = 3;
        this.scene.add( this.mesh );

        this.room = new Room(this.scene, this.world);
        this.drone = this.room.getDrone();


        
    },
    animate: function( now ){

				requestAnimationFrame( this.animate );

				this.simulate();
        
				this.render();
      }, 
      simulate:function(){
        var time = performance.now();
        if(!this.prevTime){
          this.prevTime = time;
          return;
        }

					var delta = ( time - this.prevTime ) / 1000;

          this.world.step();

          //this.mesh.rotation.x += 0.005;
          //this.mesh.rotation.y += 0.01;
          let pos =this.box.getPosition() 
          this.mesh.position.copy( pos);          
          this.mesh.quaternion.copy( this.box.getQuaternion() );

          switch(this.mode){
            case modes.fpv:
              this.fpvSimulate(delta);
              break;
            case modes.drone:
              this.droneSimulate(delta);
              break;
          }      
          this.roomSimulate(delta);      
          
          this.prevTime = time;
      },
      roomSimulate: function(delta){
          this.room.simulate(delta);
      },
      droneSimulate: function(delta){
        
      },
      fpvSimulate: function(delta){
          this.velocity.x -= this.velocity.x * 10.0 * delta;
					this.velocity.z -= this.velocity.z * 10.0 * delta;

					//this.velocity.y -= 9.8 * 100.0 * delta; // 100.0 = mass

					this.direction.z = Number( this.moveForward ) - Number( this.moveBackward );
					this.direction.x = Number( this.moveRight ) - Number( this.moveLeft );
					this.direction.normalize(); // this ensures consistent movements in all directions

          if ( this.moveForward || this.moveBackward ) 
          this.velocity.z -= this.direction.z * 100.0 * delta;
          if ( this.moveLeft || this.moveRight )
           this.velocity.x -= this.direction.x * 100.0 * delta;

					this.controls.moveRight( - this.velocity.x * delta );
					this.controls.moveForward( - this.velocity.z * delta );
          
      },
      render: function(){

        //this.renderer.render( this.scene, this.camera );
        this.composer.render();
      }
  }
  

}
</script>

<style>
.wrapper{
  width:100%;
  height:100%;  
}
.main{
  text-align: center;
  background: black; 
  width:100%;
  height:100%;  
}
canvas { display: block; }


#blocker {
				position: absolute;
				width: 100%;
				height: 100%;
				background-color: rgba(0,0,0,0.5);
			}

			#instructions {
				width: 100%;
				height: 100%;

				display: -webkit-box;
				display: -moz-box;
				display: flex;

				-webkit-box-orient: horizontal;
				-moz-box-orient: horizontal;
				box-orient: horizontal;

				-webkit-box-pack: center;
				-moz-box-pack: center;
				box-pack: center;

				-webkit-box-align: center;
				-moz-box-align: center;
				box-align: center;

				color: #ffffff;
				text-align: center;
				font-family: Arial;
				font-size: 14px;
				line-height: 24px;

				cursor: pointer;
			}

</style>
